module.exports = __webpack_public_path__ + "img/icon-excel.63c00967.svg";